import React from 'react';
import { useAnalytics } from '../../hooks/useAnalytics';

const AnalyticsWrapper: React.FC = () => {
  // Initialize analytics tracking within Router context
  useAnalytics();
  
  // This component doesn't render anything, it just initializes analytics
  return null;
};

export default AnalyticsWrapper; 